const initialInvoice = {
    invoices: [],
    singleinvoices : [],
    invoicemessages : [],
};

const InvoiceReducer = (invoice = initialInvoice, action) => {
    switch (action.type) {
        case "ADD_INVOICE":
            return {
                ...invoice, invoicemessages: action.payload.data
            };
        case "DELETE_INVOICE":
            return {
                ...invoice, invoicemessages: action.payload.data
            };
        case "GET_INVOICE":
            return {
                ...invoice, invoices: action.payload.data
            };
        case "GET_SINGLE_INVOICE":
            return {
                ...invoice, singleinvoices: action.payload.data
            };
            

        default:return invoice;
    }
}
export default InvoiceReducer;